// FAQ.jsx
import React, { useState, useEffect } from 'react';
import './FAQ.css';
import { faqData } from '../../utils';


const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(0);


  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="faq">
      <div className="faq__container">
        <div className="faq__header">
          <div className="faq__badge">
            FAQ's <span className="faq__badge-icon">↗</span>
          </div>
          <h2 className="faq__title">
            Frequently asked questions
          </h2>
          <p className="faq__subtitle">
            Everything you need to know about the product and billing.
          </p>
        </div>

        <div className="faq__list">
          {faqData.map((item, index) => (
            <div 
              className="faq__item" 
              key={item.id}
            >
              <button 
                className={`faq__question ${activeIndex === index ? 'faq__question--active' : ''}`}
                onClick={() => toggleFAQ(index)}
              >
                {item.question}
                <span className={`faq__icon ${activeIndex === index ? 'faq__icon--active' : ''}`}>
                  {activeIndex === index ? '-' : '+'}
                </span>
              </button>
              <div 
                className={`faq__answer ${activeIndex === index ? 'faq__answer--active' : ''}`}
              >
                <p>{item.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;